import { format, parseISO } from "date-fns";
import { addCalendarDays } from "@common/helpers/date";

const DAY_MS = 24 * 60 * 60_000;

/** The month before `today`, the period the fake closes cover. */
export const getDemoServicePeriod = (today: string) => {
    const endDate = addCalendarDays(`${today.slice(0, 7)}-01`, -1);
    const monthKey = endDate.slice(0, 7);
    return {
        startDate: `${monthKey}-01`,
        endDate,
        monthName: format(parseISO(`${monthKey}-15`), "MMMM"),
    };
};

/** An ISO timestamp `days` days before `now`. */
export const toDemoDaysAgoIso = ({
    now,
    days,
}: {
    now: number;
    days: number;
}) => new Date(now - days * DAY_MS).toISOString();
